export class login_formModel {
setValue(res){
if(res){
}
}
}